import React from 'react';
import ToggleMaxResultBox from "../components/ToggleMaxResultBox";
import PanelLayout from "../components/PanelLayout";

const AllItemsPanel = () => (
    <PanelLayout>
        <ToggleMaxResultBox/>
    </PanelLayout>
);

export default AllItemsPanel;